import { UnitType } from '@exodus/currency'

const name = 'stellar'
const displayName = 'Stellar'
const ticker = 'XLM'
const displayTicker = ticker
const displayNetworkTicker = displayTicker
const displayNetworkName = displayName
const baseAssetName = name
const primaryColor = '#d2d2d2'
const gradientColors = ['#EAEAEA', '#FFF']
const gradientCoords = { x1: '19.031%', y1: '-66.682%', x2: '123.324%', y2: '91.487%' }
const chainBadgeColors = gradientColors

const units = {
  stroops: 0,
  XLM: 7,
}
const currency = UnitType.create(units)

const assetType = 'RIPPLE_LIKE'
const blockExplorer = {
  addressUrl: (address) => `https://stellarchain.io/address/${encodeURIComponent(address)}`,
  txUrl: (txId) => `https://stellarchain.io/tx/${encodeURIComponent(txId)}`,
}
const info = {
  description:
    'Stellar is a payment network that uses Lumens as a cryptocurrency to provide low-cost financial solutions for both individuals and companies.',
  reddit: 'https://www.reddit.com/r/Stellar/',
  twitter: 'https://twitter.com/stellarorg',
  website: 'https://www.stellar.org/',
}

export const asset = {
  assetType,
  baseAssetName,
  blockExplorer,
  chainBadgeColors,
  currency,
  displayName,
  displayNetworkName,
  displayNetworkTicker,
  displayTicker,
  gradientColors,
  gradientCoords,
  info,
  name,
  primaryColor,
  properName: displayName, // deprecated,
  properTicker: displayTicker, // deprecated,
  ticker,
  toString: () => name,
  units,
}

export default [asset]
